import { render, staticRenderFns } from "./building.vue?vue&type=template&id=a283a5ae&scoped=true&"
var script = {}
import style0 from "./building.vue?vue&type=style&index=0&id=a283a5ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a283a5ae",
  null
  
)

export default component.exports